import { generateLogo as i } from "./index2.js";
import { getConfig as a } from "../../configuration/state/index2.js";
class m {
  imageModel;
  logoClass;
  constructor(o, s, e) {
    const t = s ?? a().values.sitebrand;
    this.imageModel = o ?? i({ siteBrand: t, cssClass: e }).imageModel, this.logoClass = e ?? "";
  }
  setLogo(o, s) {
    this.imageModel = o ?? this.imageModel, this.logoClass = s ?? "";
  }
}
export {
  m as LogoOption
};
//# sourceMappingURL=index.js.map
